/**
 * Индикатор свёрнутой группы колонок (§4.2).
 *
 * `···` — заполнены все три поля группы, `··` — два, `∅` — пусто.
 * Клик по ячейке разворачивает группу.
 */
import { tableTexts as t } from '../../texts.table.js'
import { groupColumns } from '../columns.js'
import { readCell } from '../values.js'
import type { CellProps } from './CellBox.js'

export interface GroupFoldCellProps extends CellProps {
  /** Полный каталог колонок: нужен, чтобы посчитать заполненность группы. */
  catalog: Parameters<typeof groupColumns>[0]
}

export function GroupFoldCell({ column, row, ctx, catalog, actions }: GroupFoldCellProps) {
  const group = column.foldedGroup
  if (!group) return null
  const columns = groupColumns(catalog, group)
  let filled = 0
  for (const member of columns) {
    const cell = readCell(ctx, member, row)
    if (cell && !cell.empty) filled += 1
  }
  const total = columns.length
  const glyph = filled === 0 ? '∅' : '·'.repeat(filled)

  return (
    <button
      type="button"
      className="cell__fold"
      aria-label={t.hint.foldedGroup(filled, total, column.srTitle ?? column.title)}
      onMouseDown={(event) => event.stopPropagation()}
      onClick={(event) => { event.stopPropagation(); actions.expandGroup(group) }}
    >
      {glyph}
    </button>
  )
}
